import React, { useState, useRef, useContext, useEffect } from "react";
import { Card, Form, Table, Button, Row, Col, Dropdown } from "react-bootstrap";
import {
  ErxAdviceContext,
  ErxAdviceDispatchContext,
} from "../../context/ErxContext.js";
import Loading from "../../shared/Loading";
import { DateFormat } from "../../Helper";
import api from "../../services/api";
function OtherAttachment({
  adviceSubmitUrl,
  extraReferences,
  extraData,
  id,
  newEntryForm = true,
}) {
  const adviceNoted = useContext(ErxAdviceContext);
  const setAdviceNoted = useContext(ErxAdviceDispatchContext);
  const [isLoading, setIsLoading] = useState(true);
  const [validated, setValidated] = useState(false);
  const [editFormValidated, setEditFormValidated] = useState(false);

  const adviceRef = useRef({});

  const key = "Other Attachments".replace(/ /g, "_");
  useEffect(() => {
    if (!adviceNoted[key]) {
      setAdviceNoted({ type: "init", key: key });
    }
    setIsLoading(false);
  }, []);

  const handleAdviceAdd = async (e) => {
    e.preventDefault();
    let error = false;
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      error = true;
    }
    setValidated(true);
    if (error) return false;
    let itemSelected;

    itemSelected = {
      name: adviceRef.current["name"].value,
      timestamp: Date.now(),
      files: adviceRef.current["files"].files,
      key: 0,
      ...extraData,
    };

    if (extraReferences !== undefined && extraReferences.length > 0) {
      extraReferences.forEach((ref) => {
        itemSelected[ref.current.name] = ref.current.value;
      });
    }

    try {
      const url = adviceSubmitUrl;

      const formData = new FormData();

      for (let i = 0; i < itemSelected.files.length; i++) {
        formData.append("files", itemSelected.files[i]);
      }
      formData.append("obj", JSON.stringify({ ...itemSelected, files: [] }));
      await api
        .post(url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => response.data)
        .then((data) => {
          // Handle the response data

          itemSelected = data.response;
          setAdviceNoted({ type: "add", key: key, data: itemSelected });
          form.reset();

          setValidated(false);
        })
        .catch((error) => {
          // Handle any errors
          console.log(error);
          // setIsLoading("error");
        });
    } catch (error) {
      // setIsLoading("error");
    }
  };

  const handleAdviceUpdate = async (e, timestamp) => {
    e.preventDefault();
    let error = false;
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      error = true;
    }
    setEditFormValidated(true);
    if (error) return false;
    const oldAdvice = {
      ...adviceNoted[key].find((s) => s.timestamp === timestamp),
    };
    let itemSelected = {
      name: adviceRef.current[`name_${timestamp}`].value,
      // files: oldAdvice.files,
    };
    let fileList = adviceRef.current[`files_${timestamp}`].files;
    if (fileList.length > 0)
      itemSelected["files"] = adviceRef.current[`files_${timestamp}`].files;
    itemSelected = {
      ...oldAdvice,
      ...itemSelected,
      oldFiles: oldAdvice.files,
    };

    try {
      const url = adviceSubmitUrl;

      const formData = new FormData();

      for (let i = 0; i < itemSelected.files.length; i++) {
        formData.append("files[]", itemSelected.files[i]);
      }
      formData.append("obj", JSON.stringify({ ...itemSelected, files: [] }));
      await fetch(url, {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          // Handle the response data

          itemSelected = data;
          setAdviceNoted({
            type: "update",
            key: key,
            timestamp: timestamp,
            data: itemSelected,
          });

          handleExpandRow(timestamp);
        })
        .catch((error) => {
          // Handle any errors
          console.log(error);
          setIsLoading("error");
        });
    } catch (error) {
      setIsLoading("error");
    }
  };

  const [expandedRows, setExpandedRows] = useState([]);
  // State variable to keep track which row is currently expanded.
  const [expandState, setExpandState] = useState({});
  const [editSelected, setEditSelected] = useState({});
  const handleExpandRow = (timestamp) => {
    const currentExpandedRows = expandedRows;
    const isRowExpanded = currentExpandedRows.includes(timestamp);
    if (isRowExpanded === false)
      setEditSelected({
        ...editSelected,
        [timestamp]: [adviceNoted[key].find((p) => p.timestamp === timestamp)],
      });
    let obj = expandState;
    isRowExpanded ? (obj[timestamp] = false) : (obj[timestamp] = true);
    setExpandState(obj);

    // If the row is expanded, we are here to hide it. Hence remove
    // it from the state variable. Otherwise add to it.
    let newExpandedRows = [];
    if (isRowExpanded)
      newExpandedRows = currentExpandedRows.filter((row) => row !== timestamp);
    else newExpandedRows = currentExpandedRows.concat(timestamp);

    setExpandedRows(newExpandedRows);
  };
  const handleAdviceEdit = (timestamp) => {
    let obj = expandState;
    obj[timestamp] = "edit";
    setExpandState({ ...obj });
  };

  return (
    <>
      <Card className="mb-3 d-print-none rounded-0" border="info" id={id}>
        <Card.Header as="h5" className="rounded-0 bg-info text-white">
          Other Attachments
        </Card.Header>
        <Card.Body>
          {isLoading === true ? (
            <Loading />
          ) : isLoading === "error" ? (
            <Loading failed={true} />
          ) : (
            <>
              {newEntryForm && (
                <Form
                  noValidate
                  validated={validated}
                  onSubmit={handleAdviceAdd}
                >
                  <fieldset>
                    <Row sm={3}>
                      <Col md={4}>
                        <Form.Group className="mb-3">
                          <Form.Label>Name</Form.Label>
                          <Form.Control
                            type="text"
                            ref={(el) => (adviceRef.current["name"] = el)}
                            required
                          />
                        </Form.Group>
                      </Col>

                      <Col>
                        <Form.Group className="mb-3">
                          <Form.Label>Files</Form.Label>
                          <Form.Control
                            type="file"
                            multiple
                            ref={(el) => (adviceRef.current["files"] = el)}
                            required
                          />
                        </Form.Group>
                      </Col>

                      <Col lg={12} className="text-end mb-3">
                        <Button type="submit" variant="info">
                          Add
                        </Button>
                      </Col>
                    </Row>
                  </fieldset>
                </Form>
              )}
              <Table bordered>
                <colgroup>
                  <col style={{ width: "110px" }} />
                  <col />

                  <col style={{ width: "75px" }} />
                </colgroup>
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Name</th>
                    <th>Files</th>
                  </tr>
                </thead>
                <tbody>
                  {adviceNoted[key].map((advice, index) => {
                    return (
                      <React.Fragment key={index}>
                        <tr
                          className={
                            expandState[advice.timestamp] === true
                              ? "table-warning"
                              : expandState[advice.timestamp] === "edit"
                              ? "table-danger"
                              : ""
                          }
                          key={advice.timestamp}
                        >
                          <td>
                            <DateFormat value={advice.erxDate} />
                          </td>
                          <td
                            role="button"
                            onClick={() => handleExpandRow(advice.timestamp)}
                          >
                            <strong>{advice.name}</strong>
                          </td>
                          <td>
                            {advice.files.length >= 1 && (
                              <Dropdown>
                                <Dropdown.Toggle
                                  size="sm"
                                  variant="info"
                                  id={`filelistbutton${advice.timestamp}`}
                                >
                                  Files
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                  {Array.from(advice.files).map(
                                    (file, index) => {
                                      return (
                                        <Dropdown.Item
                                          as="a"
                                          href={file.server_path}
                                          key={index}
                                          target="_blank"
                                        >
                                          {file.file_name}
                                        </Dropdown.Item>
                                      );
                                    }
                                  )}
                                </Dropdown.Menu>
                              </Dropdown>
                            )}
                          </td>
                        </tr>
                        {expandedRows.includes(advice.timestamp) && (
                          <tr>
                            <td colSpan={2}>
                              <Form
                                noValidate
                                validated={editFormValidated}
                                onSubmit={(e) =>
                                  handleAdviceUpdate(e, advice.timestamp)
                                }
                              >
                                <fieldset>
                                  <Row sm={3}>
                                    <Col md={4}>
                                      <Form.Group className="mb-3">
                                        <Form.Label>Name</Form.Label>
                                        <Form.Control
                                          type="text"
                                          ref={(el) =>
                                            (adviceRef.current[
                                              "name_" + advice.timestamp
                                            ] = el)
                                          }
                                          onChange={(selected) => {
                                            setEditSelected({
                                              ...editSelected,
                                              [advice.timestamp]: selected,
                                            });
                                          }}
                                          defaultValue={advice.name}
                                          disabled={
                                            expandState[advice.timestamp] ===
                                            true
                                          }
                                        />
                                      </Form.Group>
                                    </Col>
                                    <Col>
                                      <Form.Group className="mb-3">
                                        <Form.Label>Files</Form.Label>
                                        <Form.Control
                                          type="file"
                                          multiple
                                          ref={(el) =>
                                            (adviceRef.current[
                                              `files_${advice.timestamp}`
                                            ] = el)
                                          }
                                          disabled={
                                            expandState[advice.timestamp] ===
                                            true
                                          }
                                        />
                                        <Form.Text>
                                          Leave blank to keep file unchanged.
                                        </Form.Text>
                                      </Form.Group>
                                    </Col>

                                    <Col lg={12} className="text-end mb-3">
                                      {expandState[advice.timestamp] ===
                                        true && (
                                        <Button
                                          type="button"
                                          variant="outline-primary"
                                          onClick={() =>
                                            handleAdviceEdit(advice.timestamp)
                                          }
                                        >
                                          Edit
                                        </Button>
                                      )}
                                      {expandState[advice.timestamp] ===
                                        "edit" && (
                                        <>
                                          <input
                                            type="hidden"
                                            ref={(el) =>
                                              (adviceRef.current[
                                                "timestamp_" + advice.timestamp
                                              ] = el)
                                            }
                                          />
                                          <Button
                                            type="button"
                                            variant="outline-danger"
                                            className="ms-3"
                                            onClick={() =>
                                              handleExpandRow(advice.timestamp)
                                            }
                                          >
                                            Cancel
                                          </Button>
                                          <Button
                                            type="submit"
                                            className="ms-3"
                                            variant="outline-primary"
                                          >
                                            Update
                                          </Button>
                                        </>
                                      )}
                                    </Col>
                                  </Row>
                                </fieldset>
                              </Form>
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </Table>
            </>
          )}
        </Card.Body>
      </Card>
    </>
  );
}

export default OtherAttachment;
